import base  from "./base_controller";
import events_buy from "./controller_actions/events_buy";
import events_detail from "./controller_actions/events_detail";
import events_checkout from "./controller_actions/events_checkout";
App.controller.events = class events_controller extends base {
    constructor() {
        super();
    }
    buy() {
        console.log("Events controller buy action")
        App.main.events.buy = new events_buy()
    }

    detail() {
        console.log("Events controller detail action")
        App.main.events.detail = new events_detail()
    }
    checkout(){
        console.log("Events controller checkout action")
        App.main.events.checkout = new events_checkout()
    }
}
